"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDraggableItem = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var style_1 = require("./style");
var CustomDraggableItemHelpButtons_1 = require("./CustomDraggableItemHelpButtons");
exports.CustomDraggableItem = (0, mobx_react_1.observer)(function (props) {
    var label = props.label, type = props.type, displayButtons = props.displayButtons, selectedItemHelpButtons = props.selectedItemHelpButtons, source = props.source, draggableId = props.draggableId, handleHelpButtonClicked = props.handleHelpButtonClicked;
    return (react_1.default.createElement(style_1.StyledCustomDraggableItem, { className: 'customDraggable' },
        react_1.default.createElement("div", { className: 'labelsContainer' },
            react_1.default.createElement("label", { className: 'labelName' }, label),
            react_1.default.createElement("label", { className: 'labelType' }, type)),
        react_1.default.createElement(CustomDraggableItemHelpButtons_1.CustomDraggableItemHelpButtons, { selectedItemHelpButtons: selectedItemHelpButtons, draggableId: draggableId, displayButtons: displayButtons, handleHelpButtonClicked: handleHelpButtonClicked, source: source })));
});
